import {FormSectionHeading} from '@sollapay/ui/components';
import {Controller} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {SellerRoleToggle} from './SellerRoleToggle';
import {SellerTypeToggle} from './SellerTypeToggle';

import type {SellerType, PartyRole} from '@sollapay/enums';
import type {ComponentProps} from 'react';
import type {Control, FieldPath, FieldValues} from 'react-hook-form';

export interface SellerSideRoleSectionProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  sellerTypeName: FieldPath<TFieldValues>;
  sellerRoleName: FieldPath<TFieldValues>;
  sellerRoleOptions: PartyRole[];
  sellerRoleError?: string;
  titleSize?: ComponentProps<typeof FormSectionHeading>['titleSize'];
}

/** An option deal's roster holds both sides, so a row states its entity and which side it sits on. */
export function SellerSideRoleSection<TFieldValues extends FieldValues>({
  control,
  sellerTypeName,
  sellerRoleName,
  sellerRoleOptions,
  sellerRoleError,
  titleSize
}: SellerSideRoleSectionProps<TFieldValues>) {
  const {t} = useTranslation('trustAccounts');

  return (
    <div className="flex flex-col gap-4">
      <FormSectionHeading
        titleSize={titleSize}
        title={t('activation.packages.trustDetails.sellerDetails.sections.sellerType.title')}
        description={t(
          'activation.packages.trustDetails.sellerDetails.sections.sellerType.description'
        )}
      />

      <div className="flex flex-wrap items-start gap-6">
        <Controller
          name={sellerTypeName}
          control={control}
          render={({field}) => (
            <SellerTypeToggle
              label={t('activation.packages.trustDetails.form.fields.entityType')}
              required
              value={field.value as SellerType}
              onChange={field.onChange}
            />
          )}
        />

        <Controller
          name={sellerRoleName}
          control={control}
          render={({field}) => (
            <SellerRoleToggle
              value={field.value as PartyRole | ''}
              options={sellerRoleOptions}
              error={sellerRoleError}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    </div>
  );
}
